export interface TCerteficateState {
  data: { certeficate?: CertificateType; entity?: EntityType } | null;
  error: string | null;
  loading: boolean;
}

export interface EntityType {
  message: 'ok';
  fio_ua: string;
  email: string;
  code: string;
  cert_pdf: string;
  is_change: string;
}

export interface CertificateType {
  ukd: string;
  bitrixid: number;
  fio: string;
  work_place?: string;
  is_done: number;
  points: number;
  name_seminar: string;
  date_seminar: Date;
  adate: Date;
  is_profile?: number;
}

enum ActionTypes {
  SET_CERTEFICATE = 'SET_CERTEFICATE',

  GET_CERTEFICATE_R = 'GET_CERTEFICATE_R',
  GET_CERTEFICATE_S = 'GET_CERTEFICATE_S',
  GET_CERTEFICATE_E = 'GET_CERTEFICATE_E',

  UPDATE_CERTEFICATE_R = 'UPDATE_CERTEFICATE_R',
  UPDATE_CERTEFICATE_S = 'UPDATE_CERTEFICATE_S',
  UPDATE_CERTEFICATE_E = 'UPDATE_CERTEFICATE_E',

  UPDATE_CERTEFICATE_PROFILE_R = 'UPDATE_CERTEFICATE_PROFILE_R',
  UPDATE_CERTEFICATE_PROFILE_S = 'UPDATE_CERTEFICATE_PROFILE_S',
  UPDATE_CERTEFICATE_PROFILE_E = 'UPDATE_CERTEFICATE_PROFILE_E',
}

export default ActionTypes;
